import { markObsoleteFavoritesAsDeprecated } from './shared/markObsoleteFavoritesAsDeprecated';

export const migration_1 = markObsoleteFavoritesAsDeprecated;
